import { useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";

const useUpdate = (method = "put") => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [responseData, setResponseData] = useState(null);

  const updateData = async (url, updatedData, onSuccess) => {
    setIsLoading(true);
    try {
      const accessToken = Cookies.get("access_token");
      const response = await axios({
        method: method,
        url: url,
        data: updatedData,
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "multipart/form-data",
          "X-CLIENT-API-KEY": process.env.REACT_APP_API_KEY,
        },
      });

      if (response.status !== 200) {
        throw new Error("Failed to update data.");
      }

      setResponseData(response.data);
      setSuccessMessage(response.data.success);

      if (onSuccess) {
        onSuccess(response.data);
      }
    } catch (error) {
      if (error.response) {
        setErrorMessage(error.response.data.message || "An error occurred.");
      } else if (error.request) {
        setErrorMessage("No response received from the server.");
      } else {
        setErrorMessage(error.message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return { updateData, isLoading, errorMessage, successMessage, responseData };
};

export default useUpdate;
